/* Marinelie — die Kapitel-Galerie auf der Handmade-Seite.
   Geschoben wird ohnehin nativ; das Skript setzt nur die beiden Pfeile
   und den Zaehler. Faellt es aus, bleibt die Bahn eine Rolle. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-hm-galerie]').forEach(function (galerie) {
      var bahn = galerie.querySelector('[data-hm-bahn]');
      if (!bahn) return;
      var karten = Array.prototype.slice.call(bahn.children);
      if (!karten.length) return;

      var zurueck = galerie.querySelector('[data-hm-zurueck]');
      var vor = galerie.querySelector('[data-hm-vor]');
      var zaehler = galerie.querySelector('[data-hm-zaehler]');

      function aktuell() {
        /* Welche Karte steht in der Mitte des Fensters? */
        var mitte = bahn.scrollLeft + bahn.clientWidth / 2;
        var beste = 0;
        var abstand = Infinity;
        karten.forEach(function (k, i) {
          var d = Math.abs(k.offsetLeft + k.offsetWidth / 2 - mitte);
          if (d < abstand) { abstand = d; beste = i; }
        });
        return beste;
      }

      function malen() {
        var i = aktuell();
        if (zaehler) zaehler.textContent = (i + 1) + ' / ' + karten.length;
        if (zurueck) zurueck.disabled = i === 0;
        if (vor) vor.disabled = i === karten.length - 1;
      }

      function springen(richtung) {
        var ziel = karten[Math.min(karten.length - 1, Math.max(0, aktuell() + richtung))];
        if (!ziel) return;
        bahn.scrollTo({
          left: ziel.offsetLeft - (bahn.clientWidth - ziel.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }

      if (zurueck) zurueck.addEventListener('click', function () { springen(-1); });
      if (vor) vor.addEventListener('click', function () { springen(1); });

      var wartet = null;
      bahn.addEventListener('scroll', function () {
        window.clearTimeout(wartet);
        wartet = window.setTimeout(malen, 90);
      });

      malen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
